// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"143":"fb1ae4aa","670":"c9b8eabc"}[chunkId] + ".chunk.js";
};